import { getNestedObject, getApiUrl, CmsEditButton } from 'bloomreach-experience-react-sdk';
import { parse } from 'url';
import { QueryString, LocaleUtils, getLocalizedValue } from '@grandvision/utils';
import React__default, { PureComponent, createElement, useMemo, memo, Fragment, createContext, useContext, useCallback, useState, useEffect, Component } from 'react';
import get$1 from 'lodash/get';
import { get } from 'jsonpointer';
import { FacetId, useAlgoliaConfig, AlgoliaSearch, SearchPageHeader, ConnectedProductListing } from '@grandvision/search';
import { MediaQuery, Accordion, AccordionItem, Banner, RichBanner, ContentBanner, HighlightedContent, CategoryLinks, Certificates, PromotionBanners, ExclusiveBrands, BlogHero, BlogList, Loader, Button, Breadcrumbs as Breadcrumbs$1, Carousel, ContentTabs, RichTextArea, Video, BlogRelatedArticles, IFrame, NotificationBar, UspGroup, ScrollUpButton, BrandList, IconList, BlogDetailHeader, BlogIntro } from '@grandvision/common';
import ReactHtmlParser from 'react-html-parser';
import { Article, Container, Heading } from '@grandvision/elements';
import { FlexLayout, CookieNotification as CookieNotification$1, Footer as Footer$1, Header as Header$1, SiteNav, getLocaleSwitcherMenuLabel, getLocaleSwitcherData } from '@grandvision/layout';
import { BookAppointment } from '@grandvision/forms';
import { withIntl, useIntl, connect } from '@grandvision/state';
import { CommerceToolsApi } from '@grandvision/commercetools';
import { Helpers, FeaturedProducts, ProductPromotions, RecentlyViewedProducts } from '@grandvision/products';
import pick from 'lodash/pick';
import Cookie from 'js-cookie';
import set from 'lodash/set';
import { setUserObject, WebPage } from '@grandvision/analytics';
import { State, Utils, MyAccountMenu, Selectors, Actions } from '@grandvision/auth';
import classnames from 'classnames';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0
THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.
See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function addBeginComment(htmlElm, position, configuration, preview) {
    var beginNodeSpan = getNestedObject(configuration, ['_meta', 'beginNodeSpan', 0, 'data']);
    if (preview &&
        htmlElm &&
        beginNodeSpan &&
        !htmlElm.classList.contains('cms-begin-comment-added')) {
        htmlElm.insertAdjacentHTML(position, configuration._meta.beginNodeSpan[0].data);
        // adding an HTML class to ensure comments are not added more than once
        // this is because the comments are added through the DOM and not by React
        // so this function is fired on every re-render of the parent component
        htmlElm.classList.add('cms-begin-comment-added');
    }
}
var ManageContentButton = /** @class */ (function (_super) {
    __extends(ManageContentButton, _super);
    function ManageContentButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ManageContentButton.addButton = function (htmlElm, configuration, preview) {
        addBeginComment(htmlElm, 'afterbegin', configuration, preview);
    };
    ManageContentButton.prototype.render = function () {
        var content = this.props.content || this.props.menu || {};
        var preview = this.props.preview;
        var styles = __assign(__assign({}, this.props.styles), { position: 'relative' });
        return (React__default.createElement("div", { style: styles },
            React__default.createElement("span", { ref: function (editContentElm) {
                    ManageContentButton.addButton(editContentElm, content, preview);
                } })));
    };
    return ManageContentButton;
}(PureComponent));

function getContentByRef(ref, pageModel) {
    if (!ref || !pageModel) {
        return {};
    }
    return get(pageModel, ref) || {};
}

function composeCollection(items, pageModel, preview) {
    return items.map(function (item) {
        if ('$ref' in item) {
            var itemContent = getContentByRef(item.$ref, pageModel);
            var newItem = __assign(__assign({}, itemContent), { link: Array.isArray(itemContent.links) ? itemContent.links[0] : itemContent.links });
            if (preview) {
                newItem.manageContentButton = (createElement(ManageContentButton, { content: itemContent, preview: preview }));
            }
            return newItem;
        }
    });
}
function composeHighlightedCollection(items) {
    return items.map(function (itemContent) {
        return {
            title: itemContent.title,
            description: itemContent.description || itemContent.summary,
            image: itemContent.image || itemContent.coverImage,
            url: Array.isArray(itemContent._links)
                ? get$1(itemContent, '_links[0].site.href', null)
                : get$1(itemContent, '_links.site.href', null),
        };
    });
}
function composeUspCollection(items) {
    return items.map(function (itemContent) {
        return {
            title: itemContent.title,
            description: itemContent.description || itemContent.summary,
            image: itemContent.image,
        };
    });
}

function createMenu(configuration) {
    var items = getNestedObject(configuration, ['models', 'menu', 'siteMenuItems']);
    if (!items || !items.length) {
        return [];
    }
    return mapToMenu(items);
}
function mapToMenu(items) {
    return items.map(function (item) {
        var menuItem = {
            label: item.name,
            link: item._links.site,
        };
        if (item.parameters && Object.keys(item.parameters).length > 0) {
            menuItem.parameters = item.parameters;
        }
        if (item.childMenuItems && item.childMenuItems.length > 0) {
            menuItem.childMenuItems = mapToMenu(item.childMenuItems);
        }
        return menuItem;
    });
}

var defaultOptions = { context: true, channel: true, isMultilingual: false, locale: '' };
function createCmsUrl(cmsUrls, options) {
    var mergedOptions = __assign(__assign({}, defaultOptions), options);
    if (!cmsUrls.hostname) {
        throw new Error('hostname is required.');
    }
    var url = (cmsUrls.scheme || 'https') + "://" + cmsUrls.hostname;
    if (cmsUrls.port) {
        url += ':' + cmsUrls.port;
    }
    if (mergedOptions.context && cmsUrls.contextPath) {
        url += '/' + cmsUrls.contextPath;
    }
    if (mergedOptions.channel && cmsUrls.channelPath) {
        url += '/' + cmsUrls.channelPath;
    }
    if (mergedOptions.isMultilingual && mergedOptions.locale) {
        url += '/' + mergedOptions.locale;
    }
    return url;
}
function createResourcesUrl(resourceIds, locale, urls) {
    if (locale === void 0) { locale = ''; }
    var _a = urls.live, scheme = _a.scheme, hostname = _a.hostname;
    var _b = urls.live, port = _b.port, contextPath = _b.contextPath, channelPath = _b.channelPath;
    var url = (scheme || 'https') + "://" + hostname;
    if (port) {
        url += ':' + port;
    }
    if (contextPath) {
        url += '/' + contextPath;
    }
    url += '/api/resources';
    if (locale) {
        url += '/' + locale;
    }
    if (channelPath) {
        url += '/' + channelPath;
    }
    return url + "?resourceBundleIds=" + encodeURIComponent(resourceIds.join(','));
}

/**
 * Converts default JSON structure of bloomreach resource API to flat format:
 * { [key: string (e.g. products)]: bundle: Object<key:value> }
 */
function flattenResources(resources) {
    var bundles = resources.resourceBundles.bundles;
    var flatBundles = {};
    for (var key in bundles) {
        if (bundles.hasOwnProperty(key)) {
            // get last part of key to create a shorter key in the new object
            var newKey = key.split('.')[key.split('.').length - 1];
            var _a = bundles[key].properties, properties = _a === void 0 ? {} : _a;
            flatBundles[newKey] = properties;
        }
    }
    return flatBundles;
}

function getComponentsBy(components, comparator) {
    return components
        .reduce(function (result, component) {
        return result.concat(comparator(component) ? component : [], component.components ? getComponentsBy(component.components, comparator) : []);
    }, [])
        .filter(Boolean);
}

function getAlgoliaConfigFromBloomreach(pageModel) {
    var component = pageModel.page.components &&
        getComponentsBy(pageModel.page.components, function (x) { return x.label === 'Product catalog v2'; })[0];
    var models = (component || { models: undefined }).models;
    var ref = models && models.document && models.document.$ref;
    var content = ref ? getContentByRef(ref, pageModel) : {};
    var isEnabled = !!component;
    var presetQueryString = getPresetQueryString(content);
    var ruleContexts = content.ruleContexts || [];
    return {
        isEnabled: isEnabled,
        presetQueryString: presetQueryString,
        ruleContexts: ruleContexts,
    };
}
function getPresetQueryString(content) {
    var presetQueryString = (content.filterQuery || '').split('#')[0];
    var categoryExternalId = content.categoryExternalId || '';
    if (categoryExternalId) {
        var symbol = presetQueryString.includes('?') ? '&' : '?';
        presetQueryString += symbol + (FacetId.categoryExternalId + "=" + categoryExternalId);
    }
    return presetQueryString;
}

function getConfigurationForPath(path, pageModel) {
    var pathSegments = path.split('/');
    var currPath;
    var configuration = pageModel.page;
    while (getNestedObject(configuration, ['components', 0])) {
        // match the next path segment
        currPath = pathSegments.shift();
        configuration = getConfigurationForPathSegment(currPath, configuration);
        if (configuration && pathSegments.length === 0) {
            // this was the last path segment and we retrieved configuration, so we can return the configuration
            return configuration;
        }
    }
    return null;
}
function getConfigurationForPathSegment(pathSegment, configuration) {
    for (var componentIdx in configuration.components) {
        if (configuration.components.hasOwnProperty(componentIdx)) {
            var component = configuration.components[componentIdx];
            // asterisk serves as a wildcard
            if (pathSegment === component.name || pathSegment === '*') {
                return component;
            }
        }
    }
    return null;
}

// Gets the content for the prescription modal from the pageModel
function getModalContent(pageModel) {
    var components = getNestedObject(pageModel, [
        'page',
        'components',
    ]);
    var mainContainer = components.find(function (comp) { return comp.name === 'main'; });
    var topContainer = mainContainer &&
        mainContainer.components &&
        mainContainer.components.find(function (comp) { return comp.name === 'top-container'; });
    var richText = topContainer &&
        topContainer.components &&
        topContainer.components.find(function (comp) { return comp.label === 'Rich Text'; });
    var richTextModal = richText && richText._meta.params && richText._meta.params.template === 'modal'
        ? richText
        : undefined;
    var contentRef = getNestedObject(richTextModal, ['models', 'document', '$ref']);
    if (!richTextModal || !contentRef) {
        return;
    }
    var richTextContent = getContentByRef(contentRef, pageModel);
    return richTextContent.content.value && richTextContent.content.value;
}

var getNoAddOnsImage = function (pageModel) {
    var _a, _b, _c, _d;
    var imageRef = ((_c = (_b = (_a = getComponentsBy(pageModel.page.components, function (x) { return x.name === 'main'; })[0]) === null || _a === void 0 ? void 0 : _a.models) === null || _b === void 0 ? void 0 : _b.document) === null || _c === void 0 ? void 0 : _c.$ref) || null;
    if (!imageRef) {
        return undefined;
    }
    return (_d = getContentByRef(imageRef, pageModel)) === null || _d === void 0 ? void 0 : _d.noAddonsImage;
};

function getPageSeo(pageModel) {
    var seo = {
        canonicalUrl: '',
        description: '',
        image: {
            filename: '',
            description: null,
            url: '',
            mobileUrl: '',
        },
        title: '',
        type: '',
    };
    var components = getNestedObject(pageModel, ['page', 'components']) || [];
    var main = components.find(function (c) { return c.name === 'main'; });
    if (!main || !main.components || !main.components.length) {
        return seo;
    }
    var data = findSeoData(main.components);
    if (data !== undefined) {
        seo = data;
    }
    else {
        main.components.forEach(function (c) {
            if (c.components && c.components.length) {
                data = findSeoData(c.components);
                if (data !== undefined) {
                    seo = data;
                }
            }
        });
    }
    return seo;
}
var findSeoData = function (components) {
    var data = components.find(function (nestedC) { return nestedC.name === 'seo'; });
    if (!data || !data.models || !data.models.seoData) {
        return undefined;
    }
    return data.models.seoData;
};

var getProductTypeUsps = function (pageModel) {
    var _a, _b, _c;
    var uspRef = (pageModel.page.components && ((_c = (_b = (_a = getComponentsBy(pageModel.page.components, function (x) { return x.name === 'main'; })[0]) === null || _a === void 0 ? void 0 : _a.models) === null || _b === void 0 ? void 0 : _b.document) === null || _c === void 0 ? void 0 : _c.$ref)) ||
        null;
    if (!uspRef) {
        return undefined;
    }
    return getContentByRef(uspRef, pageModel).usps;
};

/** Safely parse labels as JSON */
var parseJsonLabel = function (label) {
    if (!label) {
        return {};
    }
    var jsonLabel = {};
    try {
        jsonLabel = JSON.parse(label);
    }
    catch (error) {
        console.warn('Error parsing json label: ' + error);
    }
    return jsonLabel;
};

/**
 * Returns a session object for a client side request.
 *
 * @param session An object with session defaults.
 */
var getClientSession = function (defaults) {
    return __assign(__assign({}, defaults), { host: window.location.host, path: window.location.pathname + (window.location.search || ''), cookie: document.cookie, search: (window.location.search && QueryString.parse(window.location.search)) || {} });
};
/**
 * Returns a session object for a server side request.
 *
 * @param req An Express.Request object.
 * @param session An object with session defaults.
 */
var getServerSession = function (req, defaults) {
    if (defaults === void 0) { defaults = {}; }
    return __assign(__assign({}, defaults), { host: req.headers.host, path: req.headers.pathname, cookie: req.headers.cookie, locale: req.locale, search: req.query });
};

function withAnchor(Component) {
    var wrappedName = Component.displayName || Component.name || 'Component';
    var withAnchor = function (props) {
        var anchorId = getNestedObject(props, ['configuration', '_meta', 'params', 'anchorId']);
        return anchorId && !props.preview ? (createElement("div", { className: "anchor-wrapper", id: anchorId, style: { marginTop: '-120px', paddingTop: '120px' } },
            createElement(Component, __assign({}, props)))) : (createElement(Component, __assign({}, props)));
    };
    withAnchor.displayName = "withAnchor(" + wrappedName + ")";
    return withAnchor;
}

/*
List of breakpoint names supported by Bloomreach. By using this list, components will always be visible
in any new breakpoint by default (no option to hide them until Bloomreach supports the new breakpoint)

If a breakpoint ever gets removed/replaced in the original enum, Bloomreach needs to be updated first to support the change
*/
var supportedBreakpoints = [
    MediaQuery.BreakpointName.PHONE,
    MediaQuery.BreakpointName.TABLET_PORTRAIT,
    MediaQuery.BreakpointName.TABLET_LANDSCAPE,
    MediaQuery.BreakpointName.DESKTOP,
];
var isComponentVisible = function (breakpoint, visibility) {
    return (!visibility || !supportedBreakpoints.includes(breakpoint) || visibility.includes(breakpoint));
};
var useBreakpointVisibility = function (_a) {
    var configuration = _a.configuration, preview = _a.preview;
    var breakpoint = MediaQuery.useBreakpoint();
    var containerVisibility = getNestedObject(configuration, ['models', 'visibility']);
    var contentVisibility = getNestedObject(configuration, ['visibility']);
    var visibility = containerVisibility
        ? containerVisibility
        : contentVisibility;
    return preview || isComponentVisible(breakpoint, visibility);
};
function WithBreakpointVisibility(Component) {
    var wrappedName = Component.displayName || Component.name || 'Component';
    var WithBreakpointVisibility = function (props) {
        return useBreakpointVisibility(props) ? createElement(Component, __assign({}, props)) : null;
    };
    WithBreakpointVisibility.displayName = "WithBreakpointVisibility(" + wrappedName + ")";
    return WithBreakpointVisibility;
}

var cmsUrls;
var isMultilingual = false;
var BloomreachService = function (multilingual) {
    if (multilingual === void 0) { multilingual = false; }
    setMultilingual(multilingual);
    function getMultilingual() {
        return isMultilingual;
    }
    function setMultilingual(value) {
        isMultilingual = value;
    }
    function getCmsUrls() {
        return cmsUrls;
    }
    function setCmsUrls(newCmsUrls) {
        cmsUrls = newCmsUrls;
    }
    function isCmsPreview(queryParams) {
        if (queryParams === void 0) { queryParams = {}; }
        var bloomreachParam = queryParams['bloomreach-preview'];
        return bloomreachParam !== undefined && bloomreachParam === 'true';
    }
    function getLocalizedCmsUrls(newCmsUrls, locale) {
        var localizedCmsUrls = __assign({}, newCmsUrls);
        if (locale) {
            locale = locale.replace('-', '_');
            localizedCmsUrls.live = __assign({}, localizedCmsUrls.live);
            localizedCmsUrls.preview = __assign({}, localizedCmsUrls.preview);
            localizedCmsUrls.live.channelPath += '/' + locale;
            localizedCmsUrls.preview.channelPath += '/' + locale;
        }
        return localizedCmsUrls;
    }
    function removeLocaleFromPath(request) {
        if (request.path) {
            // Remove locale from the path (Bloomreach setup prepends all URL with a locale)
            // This usecase may also happen if user opens a url with locale from sources like google search or typing in adress bar directly
            var locale = LocaleUtils.getLocaleFromUrl(request.path);
            request.path = locale
                ? request.path.replace("/" + locale.replace('-', '_'), '')
                : request.path;
        }
        return request;
    }
    function getBloomreachURL(request, newCmsUrls, locale) {
        return getMultilingual()
            ? getApiUrl(removeLocaleFromPath(request), getLocalizedCmsUrls(newCmsUrls, locale))
            : getApiUrl(request, newCmsUrls);
    }
    /**
     * Fetches a page model for the given url path
     */
    function fetchCmsPage(request, locale, cookie, dev) {
        if (dev === void 0) { dev = false; }
        return __awaiter(this, void 0, void 0, function () {
            var pageModel;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetchCmsPageWithResponse(request, locale, cookie, dev)];
                    case 1:
                        pageModel = (_a.sent()).pageModel;
                        return [2 /*return*/, pageModel];
                }
            });
        });
    }
    function fetchCmsPageWithResponse(request, locale, cookie, dev) {
        if (dev === void 0) { dev = false; }
        return __awaiter(this, void 0, void 0, function () {
            var url, response, pageModel, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!cmsUrls) {
                            throw new Error('cmsUrls not set.');
                        }
                        url = getBloomreachURL(request, cmsUrls, locale);
                        if (dev) {
                            console.log("Fetching " + url);
                        }
                        return [4 /*yield*/, fetch(url, { headers: { Cookie: cookie } })];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 6];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, response.json()];
                    case 3:
                        pageModel = _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        console.error("Error! could not convert page model response to JSON for URL: " + url);
                        console.error(err_1);
                        return [3 /*break*/, 5];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        console.error("Error! Status code " + response.status + " while fetching CMS page data for URL: " + url);
                        _a.label = 7;
                    case 7: return [2 /*return*/, { pageModel: pageModel, response: response }];
                }
            });
        });
    }
    /**
     * Fetches a set of resource IDs from the Bloomreach resource api.
     * Resources are usually a list of keys with localized values.
     */
    function fetchCmsResource(resourceIds, locale, urls) {
        return __awaiter(this, void 0, void 0, function () {
            var localeStr, url, response, resources, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        localeStr = locale.replace('-', '_');
                        url = createResourcesUrl(resourceIds, localeStr, urls);
                        return [4 /*yield*/, fetch(url)];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 6];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, response.json()];
                    case 3:
                        resources = _a.sent();
                        return [2 /*return*/, flattenResources(resources)];
                    case 4:
                        err_2 = _a.sent();
                        console.error("Error! could not convert resources response to JSON for URL: " + url);
                        console.error(err_2);
                        return [3 /*break*/, 5];
                    case 5: return [3 /*break*/, 7];
                    case 6:
                        console.error("Error! Status code " + response.status + " while fetching CMS resources for URL: " + url);
                        _a.label = 7;
                    case 7: return [2 /*return*/];
                }
            });
        });
    }
    /**
     * Get all data needed to be able to render a page on the server side.
     * Mainly for SEO purposes.
     */
    function getPage(_a) {
        var url = _a.url, hostname = _a.hostname, cookie = _a.cookie, locale = _a.locale, routes = _a.routes, dev = _a.dev;
        return __awaiter(this, void 0, void 0, function () {
            var _b, path, pathname, _c, query, preview, request, _d, response, pageModel, pageMeta, pageTemplate, bloomreachCmsSettings, qstring, page, error_1;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _e.trys.push([0, 2, , 3]);
                        _b = parse(url, true), path = _b.path, pathname = _b.pathname, _c = _b.query, query = _c === void 0 ? {} : _c;
                        preview = isCmsPreview(query);
                        if (pathname &&
                            (pathname.indexOf('/_next/') > -1 ||
                                pathname.indexOf('/static/') > -1 ||
                                pathname.indexOf('/public/') > -1)) {
                            return [2 /*return*/, {}];
                        }
                        request = {
                            hostname: hostname,
                            path: path || '',
                        };
                        return [4 /*yield*/, fetchCmsPageWithResponse(request, locale, cookie, dev)];
                    case 1:
                        _d = _e.sent(), response = _d.response, pageModel = _d.pageModel;
                        pageMeta = getPageMeta(pageModel);
                        pageTemplate = getPageTemplate(pageModel, routes);
                        bloomreachCmsSettings = {
                            visitorId: getBloomreachVisitorId(response.headers),
                            apiUrl: {
                                live: createCmsUrl(cmsUrls.live, {
                                    context: false,
                                    channel: false,
                                    isMultilingual: getMultilingual(),
                                    locale: locale,
                                }),
                                preview: createCmsUrl(cmsUrls.preview, {
                                    context: false,
                                    channel: false,
                                    isMultilingual: getMultilingual(),
                                    locale: locale,
                                }),
                            },
                        };
                        qstring = QueryString.stringify(query);
                        page = __assign(__assign({ request: {
                                hostname: request.hostname,
                                path: pathname + (qstring && "?" + qstring),
                            }, locale: locale,
                            pageModel: pageModel,
                            preview: preview,
                            bloomreachCmsSettings: bloomreachCmsSettings, search: query }, pageTemplate), pageMeta);
                        return [2 /*return*/, page];
                    case 2:
                        error_1 = _e.sent();
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    /**
     * Get addional meta data from the page model.
     */
    function getPageMeta(pageModel) {
        var pageRoutes = getNestedObject(pageModel, ['page', 'models', 'routes']);
        var productRoutesRef = getNestedObject(pageModel, ['page', 'models', 'productRoutes', '$ref']);
        var productRoutes = getContentByRef(productRoutesRef, pageModel).productRoutes;
        var productType = getNestedObject(pageModel, ['page', 'models', 'productType']);
        var isSolaris = productType === 'Sunglasses';
        return {
            pageRoutes: pageRoutes,
            productRoutes: productRoutes,
            productType: productType,
            isSolaris: isSolaris,
        };
    }
    /**
     * Get relevant template data from the page model so we can render the main component
     */
    function getPageTemplate(pageModel, routes) {
        if (!routes.error) {
            throw new Error('No error route defined.');
        }
        // Check if we have a pageId to overwrite the template from the pageType as it is more specific
        var pageTypeId = getNestedObject(pageModel, ['page', 'models', 'pageId']);
        if (pageTypeId && routes[pageTypeId]) {
            return {
                templatePath: routes[pageTypeId],
                statusCode: 200,
            };
        }
        var pageType = getNestedObject(pageModel, ['page', 'models', 'pageType']);
        if (pageType && routes[pageType]) {
            // Map bloomreach pageType to our templates (pages directory)
            return {
                templatePath: routes[pageType],
                statusCode: 200,
            };
        }
        console.error("No matching route found for pageModel with pageType: " + pageType + " in resource api!");
        return {
            templatePath: routes.error,
            statusCode: 404,
        };
    }
    return {
        getCmsUrls: getCmsUrls,
        setCmsUrls: setCmsUrls,
        getMultilingual: getMultilingual,
        setMultilingual: setMultilingual,
        fetchCmsPage: fetchCmsPage,
        fetchCmsResource: fetchCmsResource,
        getPage: getPage,
        getPageMeta: getPageMeta,
        isCmsPreview: isCmsPreview,
        removeLocaleFromPath: removeLocaleFromPath,
    };
};
function getBloomreachVisitorId(headers) {
    var cookie;
    headers.forEach(function (val, key) { return key === 'set-cookie' && val.includes('_visitor=') && (cookie = val); });
    return cookie ? cookie.match(/\_visitor\=(.*?)\;/)[1] : undefined;
}

var CmsAccordion = function (_a) {
    var configuration = _a.configuration, pageModel = _a.pageModel, _b = _a.block, block = _b === void 0 ? {} : _b, headingLevel = _a.headingLevel;
    // Container pages will give a configuration object, content pages will give a block
    var refs = Boolean(configuration)
        ? getNestedObject(configuration, ['models', 'pageable', 'items'])
        : block.document;
    var initiallyOpenItem = Boolean(configuration)
        ? parseInt(getNestedObject(configuration, ['_meta', 'paramsInfo', 'expandedByDefault']))
        : parseInt(block.expandedByDefault || 'None');
    var items = useMemo(function () { return refs.map(function (_a) {
        var $ref = _a.$ref;
        return getContentByRef($ref, pageModel);
    }); }, [refs, pageModel]);
    return (createElement(Accordion, null, items.map(function (item, i) {
        var _a;
        return (createElement(AccordionItem, { key: item.id, id: item.id, label: item.title, expanded: i + 1 === initiallyOpenItem, headingLevel: headingLevel }, ReactHtmlParser((_a = item.content) === null || _a === void 0 ? void 0 : _a.value)));
    })));
};
var CmsAccordion$1 = WithBreakpointVisibility(withAnchor(CmsAccordion));

var CmsArticle = function (_a) {
    var configuration = _a.configuration;
    var article = getNestedObject(configuration, ['models', 'document']);
    if (!configuration || !article) {
        return null;
    }
    var content = __assign(__assign({}, article), { links: { url: article.url } });
    return (createElement(Article, null,
        createElement(Banner, { content: content, useContainer: true })));
};
var CmsArticle$1 = memo(WithBreakpointVisibility(withAnchor(CmsArticle)));

var CmsBanner = function (_a) {
    var configuration = _a.configuration, pageModel = _a.pageModel, preview = _a.preview;
    var contentRef = getNestedObject(configuration, ['models', 'document', '$ref']);
    var bannerParams = getNestedObject(configuration, ['_meta', 'paramsInfo']);
    if (!configuration || !contentRef) {
        return createElement(Fragment, null);
    }
    var content = getContentByRef(contentRef, pageModel) || {};
    var bannerContent = {
        image: content.image,
        title: content.title,
        text: content.description,
        links: Array.isArray(content.links) ? content.links : [content.links],
    };
    switch (bannerParams.template) {
        case 'full-width':
            return (createElement(Fragment, null,
                preview && createElement(ManageContentButton, { content: content, preview: preview }),
                createElement(Banner, { content: bannerContent })));
        case 'top-banner':
            return (createElement(Fragment, null,
                preview && createElement(ManageContentButton, { content: content, preview: preview }),
                createElement(Banner, { useContainer: true, content: __assign(__assign({}, bannerContent), { useLazyLoading: false }) })));
        case 'content-banner':
            return (createElement(Fragment, null,
                preview && createElement(ManageContentButton, { content: content, preview: preview }),
                createElement(ContentBanner, { content: bannerContent, textColor: bannerParams.textColor })));
        case 'rich-banner':
            var imageLink = content.links && content.links.find(function (l) { return l.style === 'image'; });
            return (createElement(Fragment, null,
                preview && createElement(ManageContentButton, { content: content, preview: preview }),
                createElement(RichBanner, __assign({}, bannerParams, { image: content.image, imageLink: imageLink, richContent: content.content && content.content.value }))));
        default:
            return (createElement(Fragment, null, preview && (createElement("h5", null, "Banner of type: " + content.type + " is not defined in BannerSelector."))));
    }
};
var CmsBanner$1 = memo(WithBreakpointVisibility(withAnchor(CmsBanner)));

var CmsBannerCollection = function (_a) {
    var pageModel = _a.pageModel, configuration = _a.configuration, preview = _a.preview;
    var items = getNestedObject(configuration, ['models', 'pageable', 'items']);
    var template = getNestedObject(configuration, [
        '_meta',
        'params',
        'template',
    ]);
    if (!items || !items.length || !template) {
        console.error('No items found for BannerCollection in CMS model!');
        return null;
    }
    var content = {
        items: composeCollection(items, pageModel, preview),
    };
    switch (template) {
        case 'promotion-banner':
            return createElement(PromotionBanners, { content: content });
        case 'split-header-promotion':
            return createElement(PromotionBanners, { content: content, fullWidth: true });
        case 'certificates':
            return createElement(Certificates, { content: content });
        case 'main-categories':
            return createElement(CategoryLinks, { content: content });
        case 'usp':
            var pageContent = {};
            pageContent.items = composeUspCollection(content.items);
            return createElement(HighlightedContent, { content: pageContent });
        case 'rich-banner':
            var items_1 = content.items.map(function (_a) {
                var image = _a.image, links = _a.links, content = _a.content, id = _a.id;
                return ({
                    id: id,
                    image: image,
                    richContent: content && content.value,
                    imageLink: links && links.find(function (_a) {
                        var style = _a.style;
                        return style === 'image';
                    }),
                });
            });
            return (createElement("div", { className: "site-container" },
                createElement(FlexLayout, { justify: "space-between", wrap: "wrap" }, items_1.map(function (item) { return (createElement(RichBanner, __assign({}, item, { key: item.id, backgroundColor: "white", textColor: "black", bannerWidth: "full", layout: "collection" }))); }))));
        default:
            return (createElement(Fragment, null, preview && createElement("h5", null,
                "Banner of type ",
                template,
                " not defined in BannerCollection")));
    }
};
var CmsBannerCollection$1 = memo(WithBreakpointVisibility(withAnchor(CmsBannerCollection)));

var CmsBrandCollection = function (_a) {
    var pageModel = _a.pageModel, configuration = _a.configuration, preview = _a.preview;
    var template = getNestedObject(configuration, ['_meta', 'params', 'template']);
    var items = getNestedObject(configuration, ['models', 'pageable', 'items']);
    switch (template) {
        case 'exclusive-brands':
            var content = { items: [] };
            content.items = items.map(function (item) {
                if ('$ref' in item) {
                    var itemContent = getContentByRef(item.$ref, pageModel);
                    var newItem = __assign(__assign({}, itemContent.brandLogo), { link: getNestedObject(itemContent, ['_links', 'site', 'href']), title: itemContent.title });
                    if (preview) {
                        newItem.manageContentButton = (React__default.createElement(ManageContentButton, { content: itemContent, preview: preview }));
                    }
                    return newItem;
                }
            });
            return (React__default.createElement("div", null,
                React__default.createElement(ExclusiveBrands, { content: content })));
        default:
            return (React__default.createElement(React__default.Fragment, null, preview && React__default.createElement("h5", null,
                "Banner of type ",
                template,
                " not defined in BrandCollection")));
    }
};
var CmsBrandCollection$1 = React__default.memo(WithBreakpointVisibility(withAnchor(CmsBrandCollection)));

var RuntimeContext = createContext({});

var BookAppointmentWidget = function (_a) {
    var widget = _a.widget;
    var publicRuntimeConfig = useContext(RuntimeContext);
    var features = get$1(publicRuntimeConfig, 'grandvision.features') || [];
    return (createElement("div", null,
        createElement(BookAppointment, { content: widget, isLocationEnabled: features.includes('GPS_STORES'), isPlacePredictionsEnabled: features.includes('STORES_PLACE_PREDICTIONS') })));
};

var CmsWidget = function (_a) {
    var pageModel = _a.pageModel, configuration = _a.configuration, preview = _a.preview;
    var widget = getNestedObject(configuration, ['models', 'document']);
    var template = getNestedObject(configuration, ['_meta', 'params', 'template']);
    var widgetContent;
    if (widget && '$ref' in widget) {
        widgetContent = getContentByRef(widget.$ref, pageModel);
        if (preview) {
            widgetContent = __assign(__assign({}, widgetContent), { manageContentButton: createElement(ManageContentButton, { content: widgetContent, preview: preview }) });
        }
    }
    switch (template) {
        case 'book-eye-check':
            return createElement(BookAppointmentWidget, { widget: widgetContent });
        default:
            return (createElement(Fragment, null, preview && createElement("h5", null, "Widget of type: " + template + " is not defined.")));
    }
};
var CmsWidget$1 = memo(WithBreakpointVisibility(withAnchor(CmsWidget)));

var initialSettings = {
    visitorId: undefined,
    apiUrl: {
        live: '',
        preview: '',
    },
};
var BloomreachCmsContext = React__default.createContext(initialSettings);
function BloomreachCmsProvider(_a) {
    var settings = _a.settings, children = _a.children;
    return (React__default.createElement(BloomreachCmsContext.Provider, { value: __assign(__assign({}, initialSettings), settings) }, children));
}
function withBloomreachCms(Wrapped) {
    function WithBloomreachCms(props) {
        return (React__default.createElement(BloomreachCmsContext.Consumer, null, function (bloomreachSettings) { return (React__default.createElement(Wrapped, __assign({}, props, { bloomreachCms: bloomreachSettings }))); }));
    }
    var wrappedName = Wrapped.displayName || Wrapped.name || 'Component';
    WithBloomreachCms.displayName = "WithBloomreachCms(" + wrappedName + ")";
    return WithBloomreachCms;
}

var CmsBlogOverview = /** @class */ (function (_super) {
    __extends(CmsBlogOverview, _super);
    function CmsBlogOverview() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            nextPageLoading: false,
            currentPage: 1,
            blogListContent: undefined,
            blogHeroContent: undefined,
        };
        _this.getResourceUrl = function () {
            var _a = _this.props, configuration = _a.configuration, preview = _a.preview, bloomreachCms = _a.bloomreachCms;
            var apiUrl = bloomreachCms.apiUrl;
            var url = preview ? apiUrl.preview : apiUrl.live;
            var slug = getNestedObject(configuration, ['_links', 'componentRendering', 'href']);
            return url + slug;
        };
        _this.fetchNewContent = function (url) { return __awaiter(_this, void 0, void 0, function () {
            var response, pageModel, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(url)];
                    case 1:
                        response = _a.sent();
                        if (!response.ok) return [3 /*break*/, 6];
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, response.json()];
                    case 3:
                        pageModel = _a.sent();
                        return [2 /*return*/, getArticlesContent(this.props, pageModel)];
                    case 4:
                        err_1 = _a.sent();
                        console.error("Error! could not convert page model response to JSON for URL: " + url);
                        throw err_1;
                    case 5: return [3 /*break*/, 7];
                    case 6: throw new Error("Error! Status code " + response.status + " while fetching CMS page data for URL: " + url);
                    case 7: return [2 /*return*/];
                }
            });
        }); };
        _this.getExtraArticles = function (blogListContent, currentPage) { return __awaiter(_this, void 0, void 0, function () {
            var nextPageNumber, resourceUrl, resourceQuery, newContent, articles, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ nextPageLoading: true });
                        nextPageNumber = currentPage + 1;
                        resourceUrl = this.getResourceUrl();
                        resourceQuery = resourceUrl + "&page=" + nextPageNumber;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.fetchNewContent(resourceQuery)];
                    case 2:
                        newContent = _a.sent();
                        articles = blogListContent && __spread(blogListContent.articles, (newContent.blogListContent ? newContent.blogListContent.articles || [] : []));
                        if (articles) {
                            this.setState({
                                nextPageLoading: false,
                                currentPage: nextPageNumber,
                                blogListContent: __assign(__assign({}, blogListContent), { articles: articles }),
                            });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        console.error(error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.handleLoadMore = function () {
            var _a = _this.state, blogListContent = _a.blogListContent, currentPage = _a.currentPage;
            if (blogListContent && currentPage) {
                _this.getExtraArticles(blogListContent, currentPage);
            }
        };
        return _this;
    }
    CmsBlogOverview.getDerivedStateFromProps = function (nextProps, prevState) {
        if (prevState.blogListContent) {
            return prevState;
        }
        return getArticlesContent(nextProps);
    };
    CmsBlogOverview.prototype.render = function () {
        var _a = this.props, configuration = _a.configuration, intl = _a.intl;
        var _b = this.state, blogHeroContent = _b.blogHeroContent, blogListContent = _b.blogListContent;
        if (!configuration) {
            console.error('No configuration or components found for BlogOverview in CMS model!');
            return null;
        }
        if (!blogListContent) {
            return null;
        }
        var endPage = configuration.models.pageable.endPage;
        return (React__default.createElement(React__default.Fragment, null,
            blogHeroContent && React__default.createElement(BlogHero, { content: blogHeroContent }),
            React__default.createElement(BlogList, { content: blogListContent }),
            this.state.currentPage < endPage && (React__default.createElement("div", { className: "blog-list__show-more" }, this.state.nextPageLoading ? (React__default.createElement(Loader, null)) : (React__default.createElement(Button, { variant: "outline", className: "blog-list__button", color: "primary", caption: intl.getLabel('blog.articles.showMore'), onClick: this.handleLoadMore }))))));
    };
    return CmsBlogOverview;
}(PureComponent));
var CmsBlogOverview$1 = withBloomreachCms(withIntl(WithBreakpointVisibility(withAnchor(CmsBlogOverview))));
function getArticlesContent(props, request) {
    var configuration = props.configuration, pageModel = props.pageModel, preview = props.preview, intl = props.intl;
    var params = getNestedObject(configuration, ['_meta', 'params']);
    var blogData = request ? request.page : configuration;
    var highlightedArticleRef = getNestedObject(blogData, ['models', 'highlightedArticle', '$ref']);
    var highlightedArticle = getContentByRef(highlightedArticleRef, pageModel);
    var contentData = request || pageModel;
    var blogHeroContent;
    var blogListContent;
    if (highlightedArticle) {
        var coverImage = highlightedArticle.coverImage, title = highlightedArticle.title, summary = highlightedArticle.summary, url = highlightedArticle.url;
        blogHeroContent = {
            image: coverImage,
            title: title,
            summary: summary,
            link: url,
            readMoreText: intl.getLabel('blog.readArticle'),
        };
    }
    else {
        console.error('No content object supplied for highlightedArticle in CMS model!');
    }
    var items = getNestedObject(blogData, ['models', 'pageable', 'items']);
    if (items && items.length > 0) {
        var articles = items.map(function (item) {
            if ('$ref' in item) {
                var itemContent = getContentByRef(item.$ref, contentData);
                var newItem = __assign({}, itemContent);
                if (preview) {
                    newItem.manageContentButton = (React__default.createElement(ManageContentButton, { content: itemContent, preview: preview }));
                }
                return newItem;
            }
        });
        blogListContent = {
            articles: articles,
            locale: intl.locale,
            highlightedArticle: highlightedArticle,
            title: params.title || '',
            minutesText: intl.getLabel('blog.minutesToRead'),
            noArticlesText: '',
        };
    }
    else {
        console.error('No articles in CMS model!');
    }
    return { blogHeroContent: blogHeroContent, blogListContent: blogListContent };
}

var CmsBreadcrumbs = function (_a) {
    var pageModel = _a.pageModel, product = _a.product, productType = _a.productType, sku = _a.sku;
    var locale = useIntl().locale;
    var productRouteRef = getNestedObject(pageModel, ['page', 'models', 'productRoutes', '$ref']);
    var categoryRoute = getContentByRef(productRouteRef, pageModel).productRoutes.find(function (productRoute) { return productRoute.productType === productType; });
    var components = getNestedObject(pageModel, ['page', 'components']);
    var headerComponents = ((components || {}).find(function (component) { return component.name === 'header'; }) || {}).components || [];
    var mainMenuComponent = (headerComponents || {}).find(function (component) { return component.name === 'main-menu'; }) || [];
    var mainMenuItems = getNestedObject(mainMenuComponent, ['models', 'menu', 'siteMenuItems']);
    var categoryMainMenu = mainMenuItems.find(function (menuItem) { return getNestedObject(menuItem, ['_links', 'site', 'href']) === categoryRoute.route; });
    var categoryBreadcrumb = categoryMainMenu
        ? { id: 1, name: categoryMainMenu.name, url: categoryRoute.route }
        : null;
    var activeVariant = product && Helpers.getActiveVariant(product, sku);
    var productBreadcrumb = activeVariant.name && sku && categoryBreadcrumb ? { name: activeVariant.name } : null;
    if (CommerceToolsApi.isLenses(productType) || CommerceToolsApi.isContactLensBundle(productType)) {
        var productName = product && getLocalizedValue(product.name, locale);
        productBreadcrumb = productName && sku && categoryBreadcrumb ? { name: productName } : null;
    }
    var brand = ((product || {}).masterVariant.attributes.find(function (attr) { return attr.name === 'brand'; }) || {}).value ||
        '';
    if (CommerceToolsApi.isLenses(productType)) {
        brand =
            ((product || {}).masterVariant.attributes.find(function (attr) { return attr.name === 'brandName'; }) || {})
                .value || '';
    }
    var brandBreadcrumb = brand
        ? { id: 2, name: brand, url: categoryRoute.route + ("?brand=" + brand.replace(/&/g, '%26')) }
        : null;
    var breadcrumbsItems = [categoryBreadcrumb, brandBreadcrumb, productBreadcrumb];
    var breadcrumbs = breadcrumbsItems.filter(function (breadcrumb) { return breadcrumb !== null; });
    return (createElement("div", { className: "breadcrumbs-wrapper" },
        createElement(Container, null,
            createElement(Breadcrumbs$1, { pages: breadcrumbs }))));
};
var Breadcrumbs = memo(CmsBreadcrumbs);

var CmsCarousel = function (_a) {
    var pageModel = _a.pageModel, configuration = _a.configuration, preview = _a.preview, block = _a.block;
    var items = configuration
        ? getNestedObject(configuration, ['models', 'pageable', 'items'])
        : block && block.document;
    if (!items || !items.length) {
        console.error('No items found for Carousel in CMS model!');
        return null;
    }
    var content = { items: [] };
    content.items = items.map(function (item) {
        if ('$ref' in item) {
            var itemContent = getContentByRef(item.$ref, pageModel);
            var newItem = __assign(__assign({}, itemContent), { link: Array.isArray(itemContent.links) ? itemContent.links[0] : itemContent.links });
            if (preview) {
                newItem.manageContentButton = (createElement(ManageContentButton, { content: itemContent, preview: preview }));
            }
            return newItem;
        }
    });
    return (createElement(Carousel, { autoLoop: !preview }, content.items.map(function (item) { return (createElement(Fragment, { key: item.title },
        item.manageContentButton && item.manageContentButton,
        createElement(Banner, { content: item }))); })));
};
var CmsCarousel$1 = memo(WithBreakpointVisibility(withAnchor(CmsCarousel)));

var DynamicRoutes = function (_a) {
    var pageModel = _a.pageModel, children = _a.children, _b = _a.includeProductUrlSku, includeProductUrlSku = _b === void 0 ? true : _b;
    var intl = useIntl();
    var routes = getProductRoutes(pageModel);
    if (!children || !routes) {
        return null;
    }
    function formatProductUrl(product) {
        if (!CommerceToolsApi.isProductTypeName(product.productType)) {
            return '#';
        }
        var targetPath = routes.byProductType[product.productType];
        var slug = getLocalizedValue(product.slug, intl.locale);
        var sku = !!product.sku && includeProductUrlSku ? "/" + product.sku : '';
        return targetPath + "/" + slug + sku;
    }
    return children({ formatProductUrl: formatProductUrl });
};
function indexRoutes(routes) {
    return routes.reduce(function (result, route) {
        var _a, _b;
        return ({
            byProductType: __assign(__assign({}, result.byProductType), (_a = {}, _a[route.productType] = route.route, _a)),
            byId: __assign(__assign({}, result.byId), (_b = {}, _b[route.id] = route.route, _b)),
        });
    }, {});
}
function getProductRoutes(pageModel) {
    var routesRef = getNestedObject(pageModel, ['page', 'models', 'productRoutes', '$ref']);
    if (!routesRef) {
        console.log("No routes for page " + pageModel.id + ", " + pageModel.page.name);
        return undefined;
    }
    var productRoutes = getContentByRef(routesRef, pageModel).productRoutes;
    if (Array.isArray(productRoutes)) {
        return indexRoutes(productRoutes);
    }
    console.log("Could not get productRoutes $ref for page " + pageModel.id + ", " + pageModel.page.name + ", got: " + String(productRoutes));
}

var renderHighlightedArticle = function (block, pageModel, commonProps, title) {
    var blockContent = {};
    blockContent.items =
        block.document &&
            block.document.map(function (doc) {
                var itemContent = getContentByRef(doc.$ref, pageModel);
                return __assign(__assign({}, itemContent), { description: itemContent.description || itemContent.summary, image: itemContent.coverImage, url: Array.isArray(itemContent._links)
                        ? get$1(itemContent, '_links[0].site.href', null)
                        : get$1(itemContent, '_links.site.href', null) });
            });
    blockContent.title = title;
    return createElement(HighlightedContent, __assign({}, commonProps, { content: blockContent }));
};
var renderBannerCollection = function (block, pageModel, commonProps) {
    var blockContent = {};
    switch (block.template) {
        case 'usp':
            var items = (block.document && block.document.map(function (doc) { return getContentByRef(doc.$ref, pageModel); })) || [];
            blockContent.items = composeUspCollection(items);
            return createElement(HighlightedContent, __assign({}, commonProps, { content: blockContent }));
        case 'certificates':
            blockContent = {
                items: composeCollection(block.document, pageModel, false),
            };
            return createElement(Certificates, { content: blockContent });
        case 'main-categories':
            blockContent = {
                items: composeCollection(block.document, pageModel, false),
            };
            return createElement(CategoryLinks, __assign({}, commonProps, { content: blockContent }));
        case 'rich-banner':
            var bannerItems = composeCollection(block.document, pageModel, false).map(function (_a) {
                var image = _a.image, links = _a.links, content = _a.content;
                return ({
                    image: image,
                    richContent: content && content.value,
                    imageLink: links && links.find(function (_a) {
                        var style = _a.style;
                        return style === 'image';
                    }),
                });
            });
            return (createElement(Container, null,
                createElement(FlexLayout, { justify: "space-between", wrap: "wrap" }, bannerItems.map(function (item) { return (createElement(RichBanner, __assign({}, item, { key: item.id, backgroundColor: "white", textColor: "black", bannerWidth: "full", layout: "collection" }))); }))));
        default:
            return createElement("h5", null,
                "Banner of type ",
                block.template,
                " not defined in Content");
    }
};
var renderWidget = function (block, pageModel) {
    var widgetContent = {};
    if (block.document && block.document.$ref) {
        widgetContent = getContentByRef(block.document.$ref, pageModel);
    }
    switch (block.template) {
        case 'book-appointment':
            return createElement(BookAppointmentWidget, { widget: widgetContent });
    }
};
var renderCustomPackage = function (block, customComponents) {
    if (!customComponents || !block.packageId) {
        return;
    }
    var element = customComponents[block.packageId];
    return element ? createElement(element.type, __assign({}, element.props)) : null;
};
var renderComponent = function (_a) {
    var block = _a.block, idx = _a.idx, pageModel = _a.pageModel, publicRuntimeConfig = _a.publicRuntimeConfig, intl = _a.intl, routeFormatters = _a.routeFormatters, customComponents = _a.customComponents, _b = _a.preview, preview = _b === void 0 ? false : _b;
    var _c;
    var commonProps = __assign({ key: block.displayName + "|" + (block.id || idx.toString()), locale: intl.locale }, routeFormatters);
    var minutesToReadText = intl.getLabel('blog.minutesToRead');
    var highlightedArticleCollectionTitle = intl.getLabel('blog.content.highlightArticleCollectionTitle.title');
    var relatedDocumentsTitle = intl.getLabel('blog.content.relatedDocuments.title');
    var blockContent = {};
    if (block.document && block.document.$ref) {
        blockContent = getContentByRef(block.document.$ref, pageModel);
        blockContent.minutesText = minutesToReadText;
    }
    switch (block.type) {
        case 'accordion':
            return (createElement(CmsAccordion, { block: block, headingLevel: "h4", pageModel: pageModel, configuration: null, preview: preview }));
        case 'articleCollection':
            return renderHighlightedArticle(block, pageModel, commonProps, highlightedArticleCollectionTitle);
        case 'bannerCollection':
            return renderBannerCollection(block, pageModel, commonProps);
        case 'carousel':
            return (createElement(CmsCarousel, { block: block, pageModel: pageModel, configuration: null, preview: preview }));
        case 'iFrame':
            blockContent = pick(block, ['source', 'width', 'height', 'scrolling', 'position']);
            return createElement(IFrame, __assign({}, commonProps, blockContent));
        case 'relatedDocuments':
            blockContent.items =
                block.relatedDocuments &&
                    block.relatedDocuments.map(function (doc) { return getContentByRef(doc.$ref, pageModel); });
            blockContent.title = relatedDocumentsTitle;
            return createElement(BlogRelatedArticles, __assign({}, commonProps, { content: blockContent }));
        case 'recommendedProducts':
            return (createElement(FeaturedProducts, { skus: block.recommendedProducts || [], formatProductUrl: routeFormatters.formatProductUrl, staticsUrl: ((_c = publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.grandvision) === null || _c === void 0 ? void 0 : _c.staticsUrl) || '', title: intl.getLabel('blog.content.recommendedProducts.title') }));
        case 'video':
            return (createElement(Video, __assign({}, commonProps, { videoUrl: block.videoUrl || '', coverImage: block.coverImage || {} })));
        case 'banner':
            var bannerContent = __assign({}, blockContent);
            if (block.document && block.document.$ref) {
                bannerContent = getContentByRef(block.document.$ref, pageModel);
                bannerContent.link = Array.isArray(bannerContent.links)
                    ? bannerContent.links[0]
                    : bannerContent.links;
            }
            if (block.template === 'rich-banner') {
                return (createElement(RichBanner, __assign({}, block, { image: blockContent.image, imageLink: get$1(blockContent, 'links', []).find(function (l) { return l.style === 'image'; }), richContent: get$1(blockContent, 'content.value', '') })));
            }
            return (createElement(Banner, __assign({}, commonProps, { content: bannerContent, useContainer: block.template === 'top-banner' })));
        case 'richText':
            return (createElement(RichTextArea, __assign({}, commonProps, { content: block.html || '', backgroundColor: block.backgroundColor, textColor: block.textColor })));
        case 'linkList':
            return (createElement("div", { className: "site-container" },
                createElement(ContentTabs, { links: blockContent.iconLinkCompoundList.map(function (_a) {
                        var link = _a.link;
                        return link;
                    }) })));
        case 'widget':
            return renderWidget(block, pageModel);
        case 'customPackageComponent':
            return renderCustomPackage(block, customComponents);
    }
};
var Content = function (_a) {
    var content = _a.content, pageModel = _a.pageModel, publicRuntimeConfig = _a.publicRuntimeConfig, intl = _a.intl, routeFormatters = _a.routeFormatters, customComponents = _a.customComponents, _b = _a.preview, preview = _b === void 0 ? false : _b;
    var contentBlocks = content.contentBlocks;
    return contentBlocks
        .filter(function (block) {
        return useBreakpointVisibility({ configuration: block, pageModel: pageModel, preview: preview });
    })
        .map(function (block, idx) {
        var component = renderComponent({
            content: content,
            block: block,
            idx: idx,
            pageModel: pageModel,
            publicRuntimeConfig: publicRuntimeConfig,
            intl: intl,
            routeFormatters: routeFormatters,
            customComponents: customComponents,
            preview: preview,
        });
        return block.anchorId ? (createElement("div", { className: "anchor-wrapper", id: block.anchorId, style: { marginTop: '-120px', paddingTop: '120px' } }, component)) : (component);
    });
};
var CmsContent = function (_a) {
    var pageModel = _a.pageModel, rest = __rest(_a, ["pageModel"]);
    return (createElement(DynamicRoutes, { pageModel: pageModel }, function (routeFormatters) { return (createElement(Content, __assign({ pageModel: pageModel, routeFormatters: routeFormatters }, rest))); }));
};
var CmsContent$1 = memo(withIntl(CmsContent));

var CmsCookieNotification = function (_a) {
    var pageModel = _a.pageModel, preview = _a.preview, onAllowCookies = _a.onAllowCookies, bloomreachCms = _a.bloomreachCms;
    // Cookie is part of the footer model in Bloomreach
    var configuration = getConfigurationForPath('footer', pageModel);
    if (!configuration || !configuration.components || !configuration.components.length) {
        console.error('No configuration or components found for Footer in CMS model!');
        return null;
    }
    var cookieConfig = configuration.components.find(function (comp) { return comp.name === 'cookie-consent'; });
    var contentRef = getNestedObject(cookieConfig, ['models', 'document', '$ref']);
    if (!contentRef) {
        console.error('No valid content $ref supplied for cookie consent!');
        return null;
    }
    var content = getContentByRef(contentRef, pageModel);
    var allowCookies = useCallback(function () {
        onAllowCookies && onAllowCookies();
        bloomreachCms.visitorId && persistBloomreachVisitorId(bloomreachCms.visitorId);
    }, [onAllowCookies, bloomreachCms.visitorId]);
    return (createElement(Fragment, null,
        preview && createElement(ManageContentButton, { content: content, preview: preview }),
        createElement(CookieNotification$1, { content: content, onAllowCookies: allowCookies })));
};
function persistBloomreachVisitorId(visitorId) {
    // the bloomreach API responds with a set-cookie header which expires in two years, so we'll copy that value
    Cookie.set('_visitor', visitorId, { expires: 365 * 2, path: '/' });
}
var CookieNotification = memo(withBloomreachCms(CmsCookieNotification));

var CmsDocument = function (_a) {
    var configuration = _a.configuration, pageModel = _a.pageModel, preview = _a.preview;
    var contentRef = getNestedObject(configuration, ['models', 'document', '$ref']);
    var content = getContentByRef(contentRef, pageModel);
    if (!content) {
        console.error('No content object supplied for Document in CMS model!');
        return null;
    }
    var manageContentButton = preview ? (createElement(CmsEditButton, { configuration: content, preview: preview })) : null;
    switch (content.type) {
        case 'simpleContent':
            return (createElement(Fragment, null,
                preview && manageContentButton && manageContentButton,
                createElement(RichTextArea, { content: content.content && content.content.value })));
        default:
            return (createElement(Fragment, null, preview && createElement("h4", null, "DocumentSelector: Component " + (content.type || '') + " is not defined")));
    }
};
var CmsDocument$1 = memo(WithBreakpointVisibility(withAnchor(CmsDocument)));

var CmsEmpty = function (_a) {
    var configuration = _a.configuration, pageModel = _a.pageModel, preview = _a.preview;
    var contentRef = getNestedObject(configuration, ['models', 'document', '$ref']);
    var content = getContentByRef(contentRef, pageModel) || {};
    return preview ? (createElement("div", null,
        configuration.name,
        " component ",
        createElement(ManageContentButton, { content: content, preview: preview }))) : null;
};
var CmsEmpty$1 = memo(CmsEmpty);

var CmsFAQ = function (_a) {
    var configuration = _a.configuration, pageModel = _a.pageModel, preview = _a.preview;
    var isPhone = MediaQuery.useIsPhone();
    var _b = __read(useState(), 2), activeId = _b[0], setActiveId = _b[1];
    var content = useMemo(function () {
        var ref = getNestedObject(configuration, ['models', 'document', '$ref']);
        var _a = getContentByRef(ref, pageModel) || {}, faqItems = _a.faqItems, name = _a.name, title = _a.title;
        return {
            name: name,
            title: title,
            items: faqItems.map(function (i) { return ({ $ref: i.$ref }); }),
        };
    }, [configuration, pageModel]);
    var items = useMemo(function () {
        return content.items.map(function (_a) {
            var $ref = _a.$ref;
            var _b = getContentByRef($ref, pageModel) || {}, name = _b.name, question = _b.question, answer = _b.answer;
            return {
                question: question,
                id: name,
                answer: answer.value,
            };
        });
    }, [content, pageModel]);
    var handleTitleClick = useCallback(function () {
        history.replaceState(null, '', "#" + content.name);
    }, [content]);
    var handleClick = function (id) {
        return useCallback(function (expanded) {
            if (expanded && id) {
                history.replaceState(null, '', "#" + id);
            }
        }, []);
    };
    // Handle hash from url on mount
    useEffect(function () {
        var id = window.location.hash.replace(/^#/, '');
        var hasItem = items.find(function (i) { return i.id === id; }) || content.name === id;
        hasItem && setActiveId(id);
    }, [items]);
    useEffect(function () {
        if (activeId) {
            // Push onto callback queue so it runs after the DOM is updated
            setTimeout(function () {
                var node = document.getElementById(activeId);
                if (node) {
                    var headerOffset = 200;
                    var top_1 = node.getBoundingClientRect().top;
                    var to = Math.round(top_1 + window.pageYOffset) - headerOffset;
                    if (to > headerOffset) {
                        window.scrollTo(0, to);
                    }
                }
                // If the active hash is not the title, focus the related te control element
                if (activeId !== content.name) {
                    var ctrlNode = document.getElementById(activeId + "-control");
                    ctrlNode && ctrlNode.focus();
                }
            }, 250);
        }
    }, [activeId]);
    return (createElement(Container, null,
        preview && createElement(ManageContentButton, { content: content, preview: preview }),
        createElement("button", { className: "faq-title-wrapper", onClick: handleTitleClick, "aria-label": content.title },
            createElement(Heading, { id: content.name, component: "h2", variant: isPhone ? 'small' : 'medium' }, content.title)),
        createElement(Accordion, { className: "faq" }, items.map(function (item) { return (createElement(AccordionItem, { key: item.id, id: item.id, label: item.question, headingLevel: "h3", expanded: item.id === activeId, onClick: handleClick(item.id) }, ReactHtmlParser(item.answer))); }))));
};
var CmsFAQ$1 = WithBreakpointVisibility(withAnchor(CmsFAQ));

var CmsFooter = function (_a) {
    var pageModel = _a.pageModel, preview = _a.preview, siteName = _a.siteName;
    var _b;
    var configuration = getConfigurationForPath('footer', pageModel);
    var contentRef = getNestedObject(configuration, ['models', 'document', '$ref']);
    if (!configuration ||
        !configuration.components ||
        !configuration.components.length ||
        !contentRef) {
        console.error('No configuration or components found for Footer in CMS model!');
        return null;
    }
    var content = getContentByRef(contentRef, pageModel);
    var menu = createMenu(configuration.components.find(function (comp) { return comp.name === 'menu'; }));
    var logo = {
        url: (_b = pageModel.page.models) === null || _b === void 0 ? void 0 : _b.logoAlternativeUrl,
        altText: siteName || 'logo',
    };
    var footerContent = __assign(__assign({}, content), { menu: menu,
        logo: logo });
    return (createElement(Fragment, null,
        preview && createElement(ManageContentButton, { content: content, preview: preview }),
        createElement(Footer$1, { content: footerContent, siteName: siteName }),
        preview && (createElement(ManageContentButton, { styles: { top: '-80px', left: '-150px' }, menu: configuration.components[0].models.menu, preview: preview }))));
};
var Footer = memo(CmsFooter);

function isMoreSpecific(nextLink, prevLink) {
    if (nextLink === void 0) { nextLink = ''; }
    if (prevLink === void 0) { prevLink = ''; }
    var isEqual = (nextLink.match(/\//g) || []).length === (prevLink.match(/\//g) || []).length;
    if (isEqual) {
        return nextLink.length > prevLink.length;
    }
    else {
        return (nextLink.match(/\//g) || []).length > (prevLink.match(/\//g) || []).length;
    }
}
function checkIfActive(currentPath, itemPath) {
    if (currentPath === void 0) { currentPath = ''; }
    if (itemPath === void 0) { itemPath = ''; }
    // root c.q. home
    if (currentPath === '/' && itemPath === '/') {
        return true;
    }
    else {
        return currentPath.startsWith(itemPath);
    }
}
function convertToBloomreachMenuItem(items) {
    var getHref = function (item) { return (item.link ? item.link.href : ''); };
    return items.map(function (item) { return (__assign(__assign({}, item), { name: item.label, _links: { site: { href: getHref(item), type: 'external' } }, childMenuItems: [] })); });
}
var createMyAccountMobileMenuStructure = function (intl, formattedRoutes, logout, isLoggedIn) {
    var submenu = [
        {
            name: '',
            _links: {},
            childMenuItems: formattedRoutes
                ? convertToBloomreachMenuItem(Utils.getMyAccountMenuItems(logout, formattedRoutes, intl, isLoggedIn))
                : [],
        },
    ];
    return {
        name: intl.getLabel('account.menu.myAccount'),
        parameters: {
            menuKey: 'my-account',
        },
        childMenuItems: submenu,
        _links: {
            site: undefined,
        },
    };
};
var createLocaleSwitcherMenuStructure = function (availableLocales, intl) {
    var localeSwitcherMenuLabel = getLocaleSwitcherMenuLabel(intl.language);
    var localeMenuItems = getLocaleSwitcherData(availableLocales, false);
    var activeLocale = availableLocales.find(function (item) { return item.locale.replace('_', '-') === intl.locale; });
    return {
        label: localeSwitcherMenuLabel,
        parameters: { menuKey: 'locale-switcher' },
        childMenuItems: [
            {
                label: activeLocale ? activeLocale.chooseLanguage : localeSwitcherMenuLabel,
                childMenuItems: localeMenuItems,
            },
        ],
    };
};
var getCountrySwitcherUrls = function (pageModel) {
    var countrySwitcherRef = getNestedObject(pageModel, [
        'page',
        'models',
        'countrySwitcher',
        '$ref',
    ]);
    if (!countrySwitcherRef) {
        return undefined;
    }
    var content = getContentByRef(countrySwitcherRef, pageModel);
    if (!content.imageLinkList) {
        return undefined;
    }
    return content.imageLinkList.map(function (list) {
        return {
            image: list.image && list.image.url,
            label: list.link.label,
            openInNewWindow: list.link.openInNewWindow || false,
            url: list.link.url || '',
        };
    });
};
var CmsHeader = /** @class */ (function (_super) {
    __extends(CmsHeader, _super);
    function CmsHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CmsHeader.prototype.componentDidMount = function () {
        var auth = this.props.auth;
        if (State.isInitialized(auth)) {
            this.props.recoverSession();
        }
    };
    CmsHeader.prototype.componentDidUpdate = function (prevProps) {
        if (State.isUninitialized(prevProps.auth) && State.isInitialized(this.props.auth)) {
            this.props.recoverSession();
        }
    };
    CmsHeader.prototype.render = function () {
        var _a, _b;
        var _c = this.props, auth = _c.auth, pageModel = _c.pageModel, preview = _c.preview, asPath = _c.asPath, isSolaris = _c.isSolaris, intl = _c.intl, isSearchEnabledOnSmallScreens = _c.isSearchEnabledOnSmallScreens, renderCartButton = _c.renderCartButton, isMyAccountEnabled = _c.isMyAccountEnabled, formattedRoutes = _c.formattedRoutes, _d = _c.isSearchEnabled, isSearchEnabled = _d === void 0 ? function () { return false; } : _d, _e = _c.isMultilingualEnabled, isMultilingualEnabled = _e === void 0 ? function () { return false; } : _e, onSubmitSearch = _c.onSubmitSearch, logout = _c.logout, routeFormatters = _c.routeFormatters, staticsUrl = _c.staticsUrl, algoliaHeaderConfig = _c.algoliaHeaderConfig, getProductImageUrl = _c.getProductImageUrl, _f = _c.renderSiteNav, renderSiteNav = _f === void 0 ? true : _f, cookieBar = _c.cookieBar, siteName = _c.siteName;
        var configuration = getConfigurationForPath('header', pageModel);
        var countrySwitcherOptions = getCountrySwitcherUrls(pageModel);
        if (!configuration || !configuration.components || !configuration.components.length) {
            console.error('No configuration or components found for Header in CMS model!');
            return createElement(Fragment, null);
        }
        // Get appointment button link, which we use in both the header and the navigation
        var appointment = configuration.components.find(function (comp) { return comp.name === 'appointment-menu'; });
        var appointmentItems = createMenu(appointment);
        // Get all header content
        var header = configuration.components.find(function (comp) { return comp.name === 'top-menu'; });
        var headerMenu = createMenu(header);
        var headerLogo = {
            url: (_a = pageModel.page.models) === null || _a === void 0 ? void 0 : _a.logoUrl,
            altText: siteName || 'logo',
        };
        var headerLogoMobile = __assign(__assign({}, headerLogo), { url: (_b = pageModel.page.models) === null || _b === void 0 ? void 0 : _b.logoMobileUrl });
        // Get all navigation content
        var nav = configuration.components.find(function (comp) { return comp.name === 'main-menu'; });
        var isUserLoggedIn = State.getLoggedInState(auth) === 'logged-in';
        // Let analytics know if user is logged in
        setUserObject(isUserLoggedIn);
        var myAccountButton = null;
        if (isMyAccountEnabled()) {
            var myAccountMenuItems = createMyAccountMobileMenuStructure(intl, formattedRoutes, logout, isUserLoggedIn);
            var items = [];
            if (formattedRoutes) {
                var menuItems = Utils.getMyAccountMenuItems(logout, formattedRoutes, intl, isUserLoggedIn);
                items = convertToBloomreachMenuItem(menuItems);
            }
            // Put the MyAccount menu items in the main site nav (for mobile menu)
            nav = __assign(__assign({}, nav), { models: __assign(__assign({}, nav.models), { menu: __assign(__assign({}, nav.models.menu), { siteMenuItems: __spread(nav.models.menu.siteMenuItems, [myAccountMenuItems]) }) }) });
            if (formattedRoutes) {
                myAccountButton = (createElement(MyAccountMenu, { menuItems: mapToMenu(items) }));
            }
        }
        // This is the main site nav
        var navMenu = Utils.stripMenuItemsIcon(createMenu(nav));
        var activeItemIndex;
        var pageRoutes = getNestedObject(pageModel, ['page', 'models', 'routes']);
        var availableLocales = getNestedObject(pageModel, ['page', 'models', 'localeOptions']);
        if (isMultilingualEnabled()) {
            navMenu.push(createLocaleSwitcherMenuStructure(availableLocales, intl));
        }
        // Check if a sitenav item's url corresponds with the current url path
        navMenu.forEach(function (menuItem, index) {
            var previewLinkPrefix = '/site/_cmsinternal' +
                (process.env.BLOOMREACH_CHANNEL_PATH ? '/' + process.env.BLOOMREACH_CHANNEL_PATH : '');
            if (menuItem.link &&
                checkIfActive(asPath.split('?')[0], menuItem.link.href.replace(previewLinkPrefix, '')) &&
                isMoreSpecific(menuItem.link.href, get$1(navMenu[activeItemIndex], 'link.href'))) {
                activeItemIndex = index;
            }
        });
        if (typeof activeItemIndex === 'number') {
            set(navMenu[activeItemIndex], 'link.active', true);
        }
        return (createElement(Header$1, __assign({ logo: headerLogo, logoMobile: headerLogoMobile, pageRoutes: pageRoutes, menuItems: headerMenu, myAccountButton: myAccountButton, renderCartButton: renderCartButton, isSearchEnabled: isSearchEnabled(), isSearchEnabledOnSmallScreens: isSearchEnabledOnSmallScreens, isMultilingualEnabled: isMultilingualEnabled(), availableLocales: availableLocales, staticsUrl: staticsUrl, algoliaHeaderConfig: algoliaHeaderConfig, onSubmit: onSubmitSearch, getProductImageUrl: getProductImageUrl }, routeFormatters, { preview: preview, countrySwitcherOptions: countrySwitcherOptions, renderSiteNav: renderSiteNav, cookieBar: cookieBar, siteName: siteName }),
            preview && (createElement(ManageContentButton, { styles: { left: '-600px' }, menu: header.models.menu, preview: preview })),
            preview && (createElement(ManageContentButton, { styles: { left: '-100px', top: '75px' }, menu: appointment.models.menu, preview: preview })),
            preview && (createElement(ManageContentButton, { styles: { top: '-65px' }, menu: nav.models.menu, preview: preview })),
            renderSiteNav && (createElement(SiteNav, { menuItems: navMenu, appointmentItems: appointmentItems, isSolaris: isSolaris, routes: { cart: pageRoutes.cart, stores: pageRoutes.stores }, countrySwitcherOptions: countrySwitcherOptions }))));
    };
    return CmsHeader;
}(Component));
var Wrapper = function (_a) {
    var intl = _a.intl, pageModel = _a.pageModel, includeProductUrlSku = _a.includeProductUrlSku, rest = __rest(_a, ["intl", "pageModel", "includeProductUrlSku"]);
    return (createElement(RuntimeContext.Consumer, null, function (context) { return (createElement(DynamicRoutes, { pageModel: pageModel, includeProductUrlSku: includeProductUrlSku }, function (routeFormatters) {
        var _a;
        return (createElement(CmsHeader, __assign({}, rest, { pageModel: pageModel, routeFormatters: routeFormatters, staticsUrl: ((_a = context === null || context === void 0 ? void 0 : context.grandvision) === null || _a === void 0 ? void 0 : _a.staticsUrl) || '', algoliaHeaderConfig: context.algolia, intl: intl })));
    })); }));
};
var mapStateToProps = function (state) { return ({
    auth: Selectors.getAuth(state),
    formattedRoutes: Selectors.getFormattedRoutes(state),
}); };
var mapDispatchToProps = {
    logout: Actions.LogoutActions.logOut,
    recoverSession: Actions.LoginActions.recoverSession,
};
var Header = connect(mapStateToProps, mapDispatchToProps)(withIntl(Wrapper));

var CmsHeading = function (_a) {
    var configuration = _a.configuration;
    var heading = getNestedObject(configuration, ['_meta', 'paramsInfo']);
    if (!configuration || !heading) {
        return null;
    }
    var Type = heading.type;
    var alignment = getNestedObject(configuration, ['_meta', 'params', 'alignment']) || 'left';
    return createElement(Type, { className: "heading heading--" + alignment }, heading.title);
};
var CmsHeading$1 = memo(WithBreakpointVisibility(withAnchor(CmsHeading)));

var CmsNotificationBar = function (_a) {
    var configuration = _a.configuration, pageModel = _a.pageModel, preview = _a.preview;
    var contentRef = getNestedObject(configuration, ['models', 'document', '$ref']);
    var params = getNestedObject(configuration, ['_meta', 'params']);
    if (!configuration || !contentRef) {
        console.error('No configuration or components found for NotificationBar in CMS model!');
        return null;
    }
    var content = getContentByRef(contentRef, pageModel);
    var notificationContent = __assign(__assign({}, content), { theme: params.theme || 'dark', link: Array.isArray(content.links) ? content.links[0] : content.links });
    return (createElement(Fragment, null,
        preview && createElement(ManageContentButton, { content: content, preview: preview }),
        createElement(NotificationBar, { content: notificationContent })));
};
var CmsNotificationBar$1 = memo(WithBreakpointVisibility(withAnchor(CmsNotificationBar)));

var OlapicContext = React__default.createContext('');
var CmsOlapic = function (_a) {
    var intl = _a.intl, configuration = _a.configuration, preview = _a.preview;
    var publicRuntimeConfig = React__default.useContext(RuntimeContext);
    var sku = React__default.useContext(OlapicContext);
    var content = getNestedObject(configuration, ['_meta', 'params']);
    return (React__default.createElement(React__default.Fragment, null,
        preview && (React__default.createElement("div", null,
            "Olapic Configuration ",
            React__default.createElement(ManageContentButton, { content: content, preview: preview }))),
        React__default.createElement("div", { id: content.olapic }),
        React__default.createElement("script", { type: "text/javascript", defer: true, src: get$1(publicRuntimeConfig, 'olapic.url', ''), "data-instance": content.instance, "data-apikey": get$1(publicRuntimeConfig, 'olapic.apiKey', ''), "data-olapic": content.olapic, "data-tags": sku || content.tags, "data-lang": intl.locale.replace('-', '_'), "data-use-opi": "false" })));
};
var CmsOlapicWidget = React__default.memo(withIntl(WithBreakpointVisibility(withAnchor(CmsOlapic))));

var CmsPolicyBar = function (_a) {
    var configuration = _a.configuration, pageModel = _a.pageModel, preview = _a.preview;
    var contentRef = getNestedObject(configuration, ['models', 'document', '$ref']);
    var params = getNestedObject(configuration, ['_meta', 'params']);
    if (!configuration || !contentRef) {
        console.error('No configuration or components found for NotificationBar in CMS model!');
        return null;
    }
    var theme = params.theme || 'optical';
    var content = getContentByRef(contentRef, pageModel);
    var policyBarContent = __assign(__assign({}, content), { theme: theme });
    return (createElement(Fragment, null,
        preview && createElement(ManageContentButton, { content: content, preview: preview }),
        createElement(UspGroup, { content: policyBarContent })));
};
var CmsPolicyBar$1 = memo(WithBreakpointVisibility(withAnchor(CmsPolicyBar)));

var ProductCatalog = function (_a) {
    var configuration = _a.configuration, pageModel = _a.pageModel, preview = _a.preview;
    var isEnabled = useAlgoliaConfig().isEnabled;
    var intl = useIntl();
    var contentRef = getNestedObject(configuration, ['models', 'document', '$ref']);
    var content = getContentByRef(contentRef, pageModel);
    if (!content) {
        console.error('No content object supplied for ProductCatalog in CMS model!');
        return null;
    }
    if (!isEnabled) {
        console.error("You're trying to render the <ProductCatalog />, but the `AlgoliaConfig` is not configured properly.");
        return null;
    }
    var seoData = getPageSeo(pageModel);
    var amountOfHitsLabel = intl.getLabel('search.results.amount.title');
    var promotionSmall = getPromotion({ preview: preview, pageModel: pageModel, promotion: content.smallPromotion });
    var promotionBig = getPromotion({ preview: preview, pageModel: pageModel, promotion: content.bigPromotion });
    var manageContentButton = preview ? (React__default.createElement(CmsEditButton, { configuration: content, preview: preview })) : null;
    return (React__default.createElement(RuntimeContext.Consumer, null, function (publicRuntimeConfig) { return (React__default.createElement(DynamicRoutes, { pageModel: pageModel, includeProductUrlSku: publicRuntimeConfig.includeProductUrlSku }, function (_a) {
        var formatProductUrl = _a.formatProductUrl;
        return (React__default.createElement(AlgoliaSearch, null, function (stateResults) {
            var _a;
            return (React__default.createElement(React__default.Fragment, null,
                preview && manageContentButton,
                React__default.createElement(SearchPageHeader, { pageTitle: content.title, hitTitle: (stateResults && stateResults.searchResults.nbHits) + " " + amountOfHitsLabel }),
                React__default.createElement(ConnectedProductListing, { formatProductUrl: formatProductUrl, staticsUrl: ((_a = publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.grandvision) === null || _a === void 0 ? void 0 : _a.staticsUrl) || '', promotionSmall: promotionSmall, promotionBig: promotionBig, getProductImageUrls: publicRuntimeConfig.getProductImageUrls }),
                React__default.createElement(ScrollUpButton, null),
                seoData && (React__default.createElement(WebPage, { url: seoData.canonicalUrl, pageType: "ProductListing", name: seoData.title, description: seoData.description }))));
        }));
    })); }));
};
function getPromotion(_a) {
    var preview = _a.preview, pageModel = _a.pageModel, promotion = _a.promotion;
    var content = promotion && getContentByRef(promotion.$ref, pageModel);
    if (!content) {
        return undefined;
    }
    return (promotion && __assign(__assign({}, getContentByRef(promotion.$ref, pageModel)), { links: getContentByRef(promotion.$ref, pageModel).links[0], manageContentButton: preview ? (React__default.createElement(ManageContentButton, { content: promotion, preview: preview })) : undefined }));
}
var CmsProductCatalog = WithBreakpointVisibility(withAnchor(ProductCatalog));

var CmsPromotion = function (_a) {
    var configuration = _a.configuration, pageModel = _a.pageModel, preview = _a.preview;
    var contentRef = getNestedObject(configuration, ['models', 'document', '$ref']);
    var content = getContentByRef(contentRef, pageModel);
    if (!content) {
        console.error('No content object supplied for Promotion in CMS model!');
        return null;
    }
    var manageContentButton = preview ? (createElement(CmsEditButton, { configuration: content, preview: preview })) : null;
    switch (content.type) {
        case 'productPromotionsDocument':
            return (createElement(RuntimeContext.Consumer, null, function (publicRuntimeConfig) { return (createElement(DynamicRoutes, { pageModel: pageModel }, function (_a) {
                var formatProductUrl = _a.formatProductUrl;
                return (createElement(Fragment, null,
                    preview && manageContentButton && manageContentButton,
                    createElement(ProductPromotions, { staticsUrl: get$1(publicRuntimeConfig, 'grandvision.staticsUrl', ''), content: content, formatProductUrl: formatProductUrl, getProductImageUrls: publicRuntimeConfig.getProductImageUrls })));
            })); }));
        default:
            return (createElement(Fragment, null, preview && createElement("h4", null, "DocumentSelector: Component " + (content.type || '') + " is not defined")));
    }
};
var CmsPromotion$1 = memo(WithBreakpointVisibility(withAnchor(CmsPromotion)));

function rewriteCanonical(canonicalUrl, selfUrl) {
    // Strip scheme and host from url and save just the pathname parts
    var _a = __read(canonicalUrl.split('/')), path = _a.slice(3);
    return selfUrl + "/" + path.join('/');
}
function createHreflangLink(hreflang, selfUrl) {
    var absoluteUrlPattern = /^https?:\/\/|^\/\//i;
    var url = absoluteUrlPattern.test(hreflang.url)
        ? hreflang.url
        : "" + (selfUrl || '') + hreflang.url;
    var locale = hreflang.locale.replace('_', '-').toLowerCase();
    return React__default.createElement("link", { rel: "alternate", key: url, hrefLang: locale, href: url });
}
var HeadTags = function (_a) {
    var selfUrl = _a.selfUrl, siteName = _a.siteName, description = _a.description, ogUrl = _a.ogUrl, ogImage = _a.ogImage, _b = _a.headComponent, Component = _b === void 0 ? React__default.Fragment : _b, title = _a.title, _c = _a.hreflangs, hreflangs = _c === void 0 ? [] : _c, noFollow = _a.noFollow, noIndex = _a.noIndex, children = _a.children;
    var pageTitle = title ? title + " | " + siteName : siteName;
    var url = ogUrl && rewriteCanonical(ogUrl, selfUrl);
    return (React__default.createElement(Component, null,
        React__default.createElement("title", null, pageTitle),
        url && React__default.createElement("link", { rel: "canonical", href: url }),
        React__default.createElement("meta", { name: "robots", content: (noIndex ? 'noindex' : 'index') + ", " + (noFollow ? 'nofollow' : 'follow') }),
        React__default.createElement("meta", { property: "og:url", content: url }),
        React__default.createElement("meta", { property: "og:title", content: pageTitle }),
        React__default.createElement("meta", { name: "description", content: description }),
        React__default.createElement("meta", { property: "og:description", content: description }),
        React__default.createElement("meta", { name: "twitter:site", content: url }),
        React__default.createElement("meta", { name: "twitter:card", content: "summary_large_image" }),
        React__default.createElement("meta", { name: "twitter:image", content: ogImage }),
        React__default.createElement("meta", { property: "og:image", content: ogImage }),
        React__default.createElement("meta", { property: "og:image:width", content: "1200" }),
        React__default.createElement("meta", { property: "og:image:height", content: "630" }),
        hreflangs.length > 1 && hreflangs.map(function (hreflang) { return createHreflangLink(hreflang, selfUrl); }),
        children));
};
var HeadWithRunTimeContext = function (props) { return (React__default.createElement(RuntimeContext.Consumer, null, function (_a) {
    var headComponent = _a.headComponent, selfUrl = _a.selfUrl, _b = _a.site, site = _b === void 0 ? {} : _b;
    return (React__default.createElement(HeadTags, { headComponent: headComponent, selfUrl: selfUrl, siteName: site.name || '', title: props.title, description: props.description || site.description || '', ogUrl: props.ogUrl || site.url || '', ogImage: props.ogImage || site.ogImage || '', hreflangs: props.hreflangs, noIndex: props.noIndex, noFollow: props.noFollow }, props.children));
})); };

var CmsSeo = function (_a) {
    var configuration = _a.configuration, preview = _a.preview;
    var content = getNestedObject(configuration, ['models', 'seoData']);
    var noindex = content.noindex, nofollow = content.nofollow, image = content.image, title = content.title, canonicalUrl = content.canonicalUrl, description = content.description, hreflangs = content.hreflangs;
    return (React__default.createElement(React__default.Fragment, null,
        preview && (React__default.createElement("div", null,
            "SEO configuration ",
            React__default.createElement(ManageContentButton, { content: content, preview: preview }))),
        React__default.createElement(HeadWithRunTimeContext, { title: title, ogUrl: canonicalUrl, noFollow: nofollow, noIndex: noindex, description: description, ogImage: image && image.url, hreflangs: hreflangs })));
};

var CmsRecentlyViewedProducts = function (_a) {
    var pageModel = _a.pageModel;
    return (createElement(RuntimeContext.Consumer, null, function (publicRuntimeConfig) { return (createElement(DynamicRoutes, { pageModel: pageModel }, function (_a) {
        var formatProductUrl = _a.formatProductUrl;
        var _b;
        return (createElement(RecentlyViewedProducts, { staticsUrl: ((_b = publicRuntimeConfig === null || publicRuntimeConfig === void 0 ? void 0 : publicRuntimeConfig.grandvision) === null || _b === void 0 ? void 0 : _b.staticsUrl) || '', formatProductUrl: formatProductUrl }));
    })); }));
};
var CmsRecentlyViewedProducts$1 = withAnchor(WithBreakpointVisibility(CmsRecentlyViewedProducts));

var CustomPackage = function (customComponentMap) { return function (_a) {
    var configuration = _a.configuration, pageModel = _a.pageModel, preview = _a.preview;
    var visbility = getNestedObject(configuration, ['models', 'visibility']);
    if (!useBreakpointVisibility({ configuration: configuration, pageModel: pageModel, preview: preview })) {
        return null;
    }
    var packageId = getNestedObject(configuration, ['_meta', 'paramsInfo', 'packageId']);
    var element = customComponentMap[packageId];
    return (createElement(Fragment, null,
        preview && createElement("div", null,
            "Custom Component (", packageId + " is not a defined component.",
            ")"),
        element && createElement(element.type, __assign({}, element.props))));
}; };

/**
 * BlogCollectionSelector
 *
 * This component handles the selection of a components that are a collection of banner items
 * Based on the template name from the configuration object.
 * Add more cases to the switch to handle more types of banner collection components
 */
var CmsBlogCollection = function (_a) {
    var pageModel = _a.pageModel, configuration = _a.configuration, preview = _a.preview;
    var items = getNestedObject(configuration, ['models', 'pageable', 'items']);
    var template = getNestedObject(configuration, ['_meta', 'params', 'template']);
    if (!items || !items.length || !template) {
        console.error('No items found for BlogCollection in CMS model!');
        return null;
    }
    var content = {
        items: composeCollection(items, pageModel, preview),
    };
    switch (template) {
        case 'highlight':
            var pageContent = {
                items: composeHighlightedCollection(content.items),
            };
            return createElement(HighlightedContent, { content: pageContent, className: "blog-collection" });
        default:
            return (createElement(Fragment, null, preview && createElement("h5", null,
                "Template of type ",
                template,
                " not defined in BlogCollection")));
    }
};
var CmsBlogCollection$1 = memo(WithBreakpointVisibility(withAnchor(CmsBlogCollection)));

var CmsBrandList = function (_a) {
    var pageModel = _a.pageModel, configuration = _a.configuration, preview = _a.preview;
    var template = getNestedObject(configuration, ['_meta', 'params', 'template']);
    var items = getNestedObject(configuration, ['models', 'pageable', 'items']);
    var title = getNestedObject(configuration, ['_meta', 'paramsInfo', 'title']);
    var content = { title: title, items: [] };
    content.items = items.map(function (item) {
        if ('$ref' in item) {
            var itemContent = getContentByRef(item.$ref, pageModel);
            var newItem = __assign(__assign({}, itemContent.brandLogo), { link: getNestedObject(itemContent, ['_links', 'site', 'href']), title: itemContent.title });
            if (preview) {
                newItem.manageContentButton = (React__default.createElement(ManageContentButton, { content: itemContent, preview: preview }));
            }
            return newItem;
        }
    });
    switch (template) {
        case 'brand-list':
            return React__default.createElement(BrandList, { content: content });
        default:
            return (React__default.createElement(React__default.Fragment, null, preview && React__default.createElement("h5", null,
                "Banner of type ",
                template,
                " not defined in BrandList")));
    }
};
var CmsBrandList$1 = React__default.memo(WithBreakpointVisibility(withAnchor(CmsBrandList)));

var CmsIconList = function (_a) {
    var configuration = _a.configuration, pageModel = _a.pageModel, preview = _a.preview;
    var contentRef = getNestedObject(configuration, ['models', 'document', '$ref']);
    if (!configuration || !contentRef) {
        console.error('No configuration or components found for IconList in CMS model!');
        return null;
    }
    var theme = getNestedObject(configuration, ['_meta', 'paramsInfo', 'theme']);
    var content = getContentByRef(contentRef, pageModel) || {};
    return (createElement(Fragment, null,
        preview && createElement(ManageContentButton, { content: content, preview: preview }),
        createElement(IconList, { title: content.title, theme: theme, items: content.iconLinkCompoundList })));
};
var CmsIconList$1 = memo(WithBreakpointVisibility(withAnchor(CmsIconList)));

var CmsIframe = function (_a) {
    var configuration = _a.configuration, preview = _a.preview;
    var content = getNestedObject(configuration, ['models', 'iframe']);
    return (React__default.createElement(React__default.Fragment, null,
        preview && (React__default.createElement("div", null,
            "Iframe Configuration ",
            React__default.createElement(ManageContentButton, { content: content, preview: preview }))),
        React__default.createElement(IFrame, __assign({}, content))));
};
var CmsIframe$1 = React__default.memo(WithBreakpointVisibility(withAnchor(CmsIframe)));

var CmsRichText = function (_a) {
    var pageModel = _a.pageModel, configuration = _a.configuration, preview = _a.preview;
    var contentRef = getNestedObject(configuration, ['models', 'document', '$ref']);
    var template = getNestedObject(configuration, ['_meta', 'params', 'template']);
    if (!configuration || !contentRef || !template) {
        console.error('No configuration or component found for RichText in CMS model!');
        return null;
    }
    var content = getContentByRef(contentRef, pageModel);
    // Modal template is only added to be able to retrieve the content from the pageModel.
    // Current usecase is the prescription modal in the ContactLensesConfigurator.
    switch (template) {
        case 'default':
            return (createElement(Fragment, null,
                preview && createElement(ManageContentButton, { preview: preview, content: content }),
                createElement(RichTextArea, { content: get$1(content, 'content.value') })));
        case 'modal':
            return (createElement(Fragment, null, preview && (createElement(Fragment, null,
                createElement(ManageContentButton, { preview: preview, content: content }),
                createElement(RichTextArea, { content: get$1(content, 'content.value') })))));
        default:
            return (createElement(Fragment, null, preview && (createElement("h5", null,
                "RichText component of type ",
                template,
                " not defined in RichTextCollection"))));
    }
};
var CmsRichText$1 = memo(WithBreakpointVisibility(withAnchor(CmsRichText)));

var CmsVideo = function (_a) {
    var configuration = _a.configuration;
    var videoUrl = get$1(configuration, '_meta.params.videoUrl');
    var coverImage = get$1(configuration, 'models.coverImage');
    return createElement(Video, { videoUrl: videoUrl, coverImage: coverImage });
};
var CmsVideo$1 = memo(WithBreakpointVisibility(withAnchor(CmsVideo)));

var _a;
var ComponentDefinitionType;
(function (ComponentDefinitionType) {
    ComponentDefinitionType["Accordion"] = "Accordion";
    ComponentDefinitionType["Article"] = "Article";
    ComponentDefinitionType["Banner"] = "Banner";
    ComponentDefinitionType["BannerCollection"] = "Banner collection";
    ComponentDefinitionType["BlogCollection"] = "Blog Collection";
    ComponentDefinitionType["BlogOverview"] = "Blog Overview";
    ComponentDefinitionType["BrandCollection"] = "Brand collection";
    ComponentDefinitionType["BrandList"] = "Brand List";
    ComponentDefinitionType["Carousel"] = "Carousel";
    ComponentDefinitionType["CustomPackageComponent"] = "Custom Package";
    ComponentDefinitionType["IconList"] = "Icon-Link List";
    ComponentDefinitionType["Document"] = "Document";
    ComponentDefinitionType["FAQ"] = "FAQ";
    ComponentDefinitionType["Heading"] = "Heading";
    ComponentDefinitionType["IFrame"] = "IFrame";
    ComponentDefinitionType["NotificationBar"] = "Notification bar";
    ComponentDefinitionType["OlapicWidget"] = "Olapic Widget";
    ComponentDefinitionType["Page"] = "Page";
    ComponentDefinitionType["PolicyBar"] = "Policy bar";
    ComponentDefinitionType["Promotion"] = "Promotion";
    ComponentDefinitionType["ProductCatalog"] = "Product catalog v2";
    ComponentDefinitionType["RichText"] = "Rich Text";
    ComponentDefinitionType["Seo"] = "Seo";
    ComponentDefinitionType["Translation"] = "Translation";
    ComponentDefinitionType["Video"] = "Video";
    ComponentDefinitionType["Widget"] = "Widget";
    ComponentDefinitionType["RecentlyViewedProducts"] = "Recently viewed products";
})(ComponentDefinitionType || (ComponentDefinitionType = {}));
// prettier-ignore
var defaultComponentDefinitions = (_a = {},
    _a[ComponentDefinitionType.Accordion] = { component: CmsAccordion$1, wrapInContentComponent: false },
    _a[ComponentDefinitionType.Article] = { component: CmsArticle$1, wrapInContentComponent: false },
    _a[ComponentDefinitionType.Banner] = { component: CmsBanner$1, wrapInContentComponent: false },
    _a[ComponentDefinitionType.BannerCollection] = { component: CmsBannerCollection$1, wrapInContentComponent: false },
    _a[ComponentDefinitionType.BlogCollection] = { component: CmsBlogCollection$1, wrapInContentComponent: false },
    _a[ComponentDefinitionType.BlogOverview] = { component: CmsBlogOverview$1, wrapInContentComponent: false },
    _a[ComponentDefinitionType.BrandCollection] = { component: CmsBrandCollection$1, wrapInContentComponent: false },
    _a[ComponentDefinitionType.BrandList] = { component: CmsBrandList$1, wrapInContentComponent: false },
    _a[ComponentDefinitionType.Carousel] = { component: CmsCarousel$1, wrapInContentComponent: false },
    _a[ComponentDefinitionType.CustomPackageComponent] = { component: CustomPackage, wrapInContentComponent: false },
    _a[ComponentDefinitionType.Document] = { component: CmsDocument$1, wrapInContentComponent: false },
    _a[ComponentDefinitionType.FAQ] = { component: CmsFAQ$1, wrapInContentComponent: false },
    _a[ComponentDefinitionType.Heading] = { component: CmsHeading$1, wrapInContentComponent: false },
    _a[ComponentDefinitionType.IconList] = { component: CmsIconList$1, wrapInContentComponent: false },
    _a[ComponentDefinitionType.IFrame] = { component: CmsIframe$1, wrapInContentComponent: false },
    _a[ComponentDefinitionType.NotificationBar] = { component: CmsNotificationBar$1, wrapInContentComponent: false },
    _a[ComponentDefinitionType.OlapicWidget] = { component: CmsOlapicWidget, wrapInContentComponent: false },
    _a[ComponentDefinitionType.Page] = { component: CmsEmpty$1, wrapInContentComponent: false },
    _a[ComponentDefinitionType.PolicyBar] = { component: CmsPolicyBar$1, wrapInContentComponent: false },
    _a[ComponentDefinitionType.ProductCatalog] = { component: CmsProductCatalog, wrapInContentComponent: false },
    _a[ComponentDefinitionType.Promotion] = { component: CmsPromotion$1, wrapInContentComponent: false },
    _a[ComponentDefinitionType.RichText] = { component: CmsRichText$1, wrapInContentComponent: false },
    _a[ComponentDefinitionType.Seo] = { component: CmsSeo, wrapInContentComponent: false },
    _a[ComponentDefinitionType.Translation] = { component: CmsEmpty$1, wrapInContentComponent: false },
    _a[ComponentDefinitionType.Video] = { component: CmsVideo$1, wrapInContentComponent: false },
    _a[ComponentDefinitionType.Widget] = { component: CmsWidget$1, wrapInContentComponent: false },
    _a[ComponentDefinitionType.RecentlyViewedProducts] = { component: CmsRecentlyViewedProducts$1, wrapInContentComponent: false },
    _a);

var BlogLayout = function (_a) {
    var content = _a.content, pageModel = _a.pageModel, _b = _a.labels, labels = _b === void 0 ? {} : _b, publicRuntimeConfig = _a.publicRuntimeConfig;
    var title = content.title, summary = content.summary, coverImage = content.coverImage, publishDate = content.publishDate, readingTime = content.readingTime, localeString = content.localeString;
    if (!labels || !labels.blog) {
        labels.blog = {};
    }
    var minutesToReadText = labels.blog.minutesToRead || '';
    var seoData = getPageSeo(pageModel);
    return (createElement("div", { className: "blog-layout" },
        createElement(BlogDetailHeader, { content: {
                title: title,
                coverImage: coverImage,
                scrollTo: 'blog-content-start',
            } }),
        createElement(BlogIntro, { content: {
                summary: summary,
                publishDate: publishDate,
                readingTime: readingTime,
                minutesText: minutesToReadText,
                locale: localeString,
            } }),
        createElement("article", { className: "blog-content", id: "blog-content-start" }, createElement(CmsContent$1, { content: content, pageModel: pageModel, publicRuntimeConfig: publicRuntimeConfig })),
        seoData && (createElement(WebPage, { url: seoData.canonicalUrl, pageType: "Information", name: content.title, description: content.summary }))));
};

var ContentLayout = function (_a) {
    var content = _a.content, _b = _a.pageName, pageName = _b === void 0 ? '' : _b, pageModel = _a.pageModel, publicRuntimeConfig = _a.publicRuntimeConfig, customComponents = _a.customComponents;
    var bannerContent = { image: content.coverImage };
    var seoData = getPageSeo(pageModel);
    var classNames = classnames('content-layout', {
        'content-layout--brand': pageName === 'brand-detail',
    });
    return (createElement("div", { className: classNames },
        bannerContent && bannerContent.image && (createElement(Banner, { content: bannerContent, useContainer: true, "data-t": "content-banner" })),
        content.title && (createElement("h1", { className: "content-layout__title", "data-t": "content-title" }, content.title)),
        content.summary && (createElement("div", { className: "content-layout__summary rich-text-area", "data-t": "content-summary" },
            createElement("p", { dangerouslySetInnerHTML: { __html: content.summary } }))),
        createElement("article", { className: "content", id: "content-start" },
            createElement(CmsContent$1, { content: content, pageModel: pageModel, publicRuntimeConfig: publicRuntimeConfig, customComponents: customComponents })),
        seoData && (createElement(WebPage, { url: seoData.canonicalUrl, pageType: "Information", name: content.title, description: content.summary }))));
};

/**
 * Link to a page outside the current application.
 */
var TYPE_LINK_EXTERNAL = 'external';
/**
 * Link to a page inside the current application.
 */
var TYPE_LINK_INTERNAL = 'internal';
/**
 * Link to a CMS resource.
 */
var TYPE_LINK_RESOURCE = 'resource';
var TYPE_META_COMMENT = 'comment';
/**
 * Generic component type.
 */
var TYPE_COMPONENT = 'COMPONENT';
/**
 * Container item type.
 */
var TYPE_COMPONENT_CONTAINER_ITEM = 'CONTAINER_ITEM_COMPONENT';
/**
 * Container type.
 */
var TYPE_COMPONENT_CONTAINER = 'CONTAINER_COMPONENT';



var bloomreach = /*#__PURE__*/Object.freeze({
    __proto__: null
});

export { BlogLayout, bloomreach as BloomreachApi, BloomreachCmsContext, BloomreachCmsProvider, BloomreachService, CmsAccordion$1 as CmsAccordion, CmsArticle$1 as CmsArticle, CmsBanner$1 as CmsBanner, CmsBannerCollection$1 as CmsBannerCollection, CmsBlogOverview$1 as CmsBlogOverview, CmsBrandCollection$1 as CmsBrandCollection, Breadcrumbs as CmsBreadcrumbs, CmsCarousel$1 as CmsCarousel, CmsContent$1 as CmsContent, CookieNotification as CmsCookieNotification, CmsDocument$1 as CmsDocument, CmsEmpty$1 as CmsEmpty, CmsFAQ$1 as CmsFAQ, Footer as CmsFooter, Header as CmsHeader, CmsHeading$1 as CmsHeading, CmsNotificationBar$1 as CmsNotificationBar, CmsOlapicWidget as CmsOlapic, CmsPolicyBar$1 as CmsPolicyBar, CmsProductCatalog, CmsPromotion$1 as CmsPromotion, CmsRecentlyViewedProducts$1 as CmsRecentlyViewedProducts, CmsSeo, CmsWidget$1 as CmsWidget, ComponentDefinitionType, ContentLayout, CustomPackage, DynamicRoutes, HeadWithRunTimeContext as HeadTags, ManageContentButton, OlapicContext, RuntimeContext, TYPE_COMPONENT, TYPE_COMPONENT_CONTAINER, TYPE_COMPONENT_CONTAINER_ITEM, TYPE_LINK_EXTERNAL, TYPE_LINK_INTERNAL, TYPE_LINK_RESOURCE, TYPE_META_COMMENT, WithBreakpointVisibility, composeCollection, composeHighlightedCollection, composeUspCollection, createCmsUrl, createMenu, createResourcesUrl, defaultComponentDefinitions, flattenResources, getAlgoliaConfigFromBloomreach, getClientSession, getComponentsBy, getConfigurationForPath, getContentByRef, getModalContent, getNoAddOnsImage, getPageSeo, getProductTypeUsps, getServerSession, mapToMenu, parseJsonLabel, renderComponent, useBreakpointVisibility, withAnchor, withBloomreachCms };
//# sourceMappingURL=index.es.js.map
